/* src/app/system-utils/post-chip-dd/post-chip-dd.component.scss */
.post-it {
  border: solid 1px var(--tem-border);
  background: var(--tem-surface);
  box-shadow: var(--tem-shadow);
  margin: 10px;
  border-radius: var(--tem-radius);
  padding: 10px;
  width: 400px;
  height: 100px;
  overflow: auto;
}
.chip-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
}
.chip-list nz-tag {
  cursor: grab;
  margin: 0;
}
.post-it:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 15px;
  border: 10px solid;
  border-color: transparent transparent var(--tem-surface) transparent;
}
/*# sourceMappingURL=post-chip-dd.component.css.map */
